import { render, staticRenderFns } from "./CreateInstrType.vue?vue&type=template&id=1f624232&scoped=true"
import script from "./CreateInstrType.vue?vue&type=script&lang=js"
export * from "./CreateInstrType.vue?vue&type=script&lang=js"
import style0 from "./CreateInstrType.vue?vue&type=style&index=0&id=1f624232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f624232",
  null
  
)

export default component.exports